import { useContext } from "react";
import { SoftValidationContext } from "../../contexts/soft-validation/soft-validation-provider";

export const useSoftValidation = () => useContext(SoftValidationContext);
